
import {
  computed,
  defineComponent,
  ref,
  useContext,
  useRoute,
  watch,
} from '@nuxtjs/composition-api'
import { useTranslator } from '~/src/composables/dependency'
import { PortalPageType } from '~/types/portal'
import { usePathMapping } from '~/src/composables/usePathMapping'

export default defineComponent({
  layout: 'base',
  setup() {
    const route = useRoute()
    const { getPages } = usePathMapping()
    const { error } = useContext()

    const translator = useTranslator()
    const path = computed(() => route.value.path)
    const component = ref<string>('')
    const componentProps = ref<Record<string, unknown>>({})

    watch(
      path,
      (newPath) => {
        const page = getPages(newPath)?.[0]

        if (!page) {
          error({
            statusCode: 404,
            message: translator.t('errorPage.404.title').toString(),
          })
          return
        }

        switch (page.type) {
          case PortalPageType.MODULE:
            component.value = 'ModulePage'
            componentProps.value = {
              id: page.route.name,
              config: page,
            }
            break
          case PortalPageType.IFRAME:
            component.value = 'IframePage'
            componentProps.value = {
              title: page.title,
              src: page.src,
            }
            break
          case PortalPageType.NAVIGATION:
            component.value = 'NavigationPage'
            componentProps.value = {
              title: page.title,
              description: page.description,
              items: page.items,
            }
            break
        }
      },
      {
        immediate: true,
      }
    )

    return { component, componentProps }
  },
})
